exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".profit-select[data-v-0daaae3e] select {\n  border-color: #e1e1e1;\n  background-color: #f2f2f2;\n}\n@media (min-width: 1024px) {\n.profit-select[data-v-0daaae3e] select {\n    background-color: #ffffff;\n    width: 216px;\n}\n}\n.profit-select[data-v-0daaae3e] .icon {\n  width: 8px;\n}\n", ""]);

// exports
